<template>
    <SettingsLayout>
        <!-- <Head title="Stammdaten - Grundeinstellungen" /> -->
        <Head :title="`${page_name} - Grundeinstellungen`" />

        <template #breadcrumb>{{ page_name }}</template>
        <template #controls>
            <HeaderLink
                class="mr-3"
                href="/einstellungen/behandlungsgruppen"
                type="close"
                >Zurück</HeaderLink
            >
            <HeaderButton
                v-if="canDelete"
                class="mr-3"
                @click="deleteGroup()"
                type="close"
                >Löschen</HeaderButton
            >
            <HeaderButton :disabled="form.processing" @click="submitForm()"
                >Speichern</HeaderButton
            >
        </template>
        <Heading title="Behandlungsgruppe bearbeiten" />

        <p class="max-w-2xl text-sm text-oteoText">
            Für das Anlegen von Terminserien können Sie vorab Behandlungsgruppen
            festlegen. Hierfür legen Sie einfach die einzelnen Schritte einer
            Behandlungsgruppe an, indem Sie sie aus den Behandlungstypen
            auswählen.
        </p>

        <div class="max-w-xl mt-8">
            <Label>Benennung Behandlungsgruppe</Label>
            <Input
                placeholder="Bitte eintragen"
                class="w-full"
                v-model="form.name"
            />
            <div class="mt-2 text-red-600 text-sm" v-if="errors.name">
                {{ errors.name }}
            </div>
        </div>

        <hr class="my-8" />

        <div class="flex gap-3 text-oteoText text-sm font-semibold mb-2">
            <div class="pl-1 basis-[4.5%]">Nr.</div>
            <div class="pl-1 basis-[20%]">
                Behandlungstyp
                <!-- <span class="font-light">(optional)</span> -->
            </div>
            <div class="pl-1 basis-[29%]">Anmerkungen</div>
            <div class="pl-1 basis-[11%]">Dauer</div>
            <div class="pl-1 basis-[14.5%]">Folgebehandlung ab</div>
            <div class="pl-1 basis-[21%]">Mögliche Behandler/in</div>
        </div>

        <div
            v-for="(step, index) in steps"
            :key="step.key"
            class="flex gap-3 text-oteoText mb-3 relative"
        >
            <div class="absolute -left-7 top-1/2 -translate-y-1/2">
                <i
                    @click="deleteStep(index)"
                    class="las la-times cursor-pointer"
                ></i>
            </div>
            <div class="basis-[4.5%]">
                <Input class="w-full text-center" disabled :value="index + 1" />
            </div>
            <div class="basis-[20%]">
                <Select
                    v-model="step.type_id"
                    @change="updateStep(index)"
                    class="w-full"
                    :class="{
                        'bg-red-100': errors['steps.' + index + '.type_id'],
                    }"
                >
                    <option :disabled="true" value="">Bitte wählen</option>
                    <option
                        v-for="myType in types"
                        :key="myType.id"
                        :value="myType.id"
                    >
                        {{ myType.name }}
                    </option>
                </Select>
            </div>
            <div class="basis-[29%]">
                <Input
                    placeholder="Bitte eintragen"
                    v-model="step.annotation"
                    class="w-full"
                    :class="{
                        'bg-red-100': errors['steps.' + index + '.annotation'],
                    }"
                />
            </div>
            <div class="basis-[11%]">
                <Select
                    disabled
                    v-model="step.duration"
                    class="w-full"
                    :class="{
                        'bg-red-100': errors['steps.' + index + '.duration'],
                    }"
                >
                    <option v-for="n in 10" :key="n" :value="n">
                        {{ n * interval }} Min.
                    </option>
                </Select>
            </div>
            <div class="basis-[14.5%]">
                <Select
                    v-model="step.follow_up"
                    class="w-full"
                    :class="{
                        'bg-red-100': errors['steps.' + index + '.follow_up'],
                    }"
                >
                    <option value="0">Sofort</option>
                    <option v-for="n in 14" :key="n" :value="n">
                        {{ $filters.pluralize(n, "Tag", "Tagen") }}
                    </option>
                </Select>
            </div>
            <div class="basis-[21%]">
                <!-- <Select
          v-model="step.practitioner_id"
          class="w-full"
          :class="{
            'bg-red-100': errors['steps.' + index + '.practitioner_id'],
          }"
        >
          <option :value="-1">Bitte wählen</option>
          <option
            v-for="practitioner in practitioners"
            :key="practitioner.id"
            :value="practitioner.id"
          >
            {{ practitioner.firstname + " " + practitioner.lastname }}
          </option>
        </Select> -->

                <MultiSelect
                    :key="step.myKey"
                    :hasError="errors['steps.' + index + '.practitioner_id']"
                    @valueChange="(e) => (step.practitioner_id = e)"
                    :options="
                        practitioners.map((p) => {
                            return {
                                value: p.id,
                                text: p.firstname + ' ' + p.lastname,
                                label: p.username,
                                selected: step.practitioner_id.includes(p.id),
                            };
                        })
                    "
                />
            </div>
        </div>
        <div class="flex justify-center mt-8">
            <Button @click="addStep()" class="">
                Neuen Schritt hinzufügen
            </Button>
        </div>
    </SettingsLayout>
</template>

<script setup>
const page_name = "Behandlungsgruppen";
let stepCounter = 0;
const props = defineProps({
    errors: Object,
    interval: Number,
    types: Array,
    practitioners: Array,
    group: Object,
    steps: Array,
});

const canDelete = Inertia.page.props.auth.can["delete settings"];
let saveBtnClicked = false;

//onUnmounted(
//    Inertia.on("before", (e) => {
//        if (form.isDirty && !saveBtnClicked) {
//            return confirm(
//                "Sie haben ungespeicherte Eingaben. Wollen Sie diese Seite wirklich verlassen?"
//            );
//        }
//    })
//);

let emptyStep = {
    key: stepCounter,
    type_id: "",
    annotation: "",
    duration: 1,
    follow_up: 0,
    practitioner_id: [],
    myKey: 0,
};

const steps = ref(props.steps);

onMounted(() => {
    console.log(props.steps);
});

function updateStep(index) {
    let type = props.types.find((t) => t.id == steps.value[index].type_id);
    steps.value[index].practitioner_id = type.practitioners;
    let duration = type.duration;
    steps.value[index].duration = duration;
    steps.value[index].myKey++;
}

function addStep() {
    stepCounter++;
    emptyStep.order = stepCounter;
    steps.value.push({ ...emptyStep });
}

function deleteStep(index) {
    steps.value.splice(index, 1);
}

function submitForm() {
    saveBtnClicked = true;
    form.put(`/groups/${props.group.id}`);
}

function deleteGroup() {
    Inertia.delete(
        `/groups/${props.group.id}`,
        {},
        { preserveState: true, replace: true }
    );
}

const form = useForm({
    name: props.group.name,
    steps: steps,
});

import TD from "@/Components/Table/Element.vue";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Textarea from "@/Components/Textarea.vue";
import Select from "@/Components/Select.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";
import Button from "@/Components/Button.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { ref, computed, onMounted } from "vue";
import MultiSelect from "@/Components/MultiSelect.vue";
import { onUnmounted } from "vue";
</script>
